import i18n from 'i18next'

export const getDataUrl = (filename) => {
  const lang = i18n.language?.split('-')[0] || 'en'
  return `/locales/${lang}/${filename}`
}
